export type ProgressStep = { type: "progress"; value: number };
export type DetailedProgress = {
  step: string;
  processed?: number;
  total?: number;
};
export type DetailedProgressStep = {
  type: "detailed_progress";
  value: DetailedProgress;
};
export type CompleteStep = { type: "complete"; value: { workspaceId: string } };
export type ErrorStep = { type: "error"; value: string };
export type StreamStep =
  | ProgressStep
  | DetailedProgressStep
  | CompleteStep
  | ErrorStep;

export enum UploadActionType {
  START = "START",
  PROGRESS = "PROGRESS",
  ERROR = "ERROR",
  OPEN_WORKSPACE = "OPEN_WORKSPACE",
}

export type UploadAction =
  | ReturnType<typeof startUpload>
  | ReturnType<typeof progress>
  | ReturnType<typeof error>
  | ReturnType<typeof uploadComplete>;

export const progress = (progress: DetailedProgress) => ({
  type: UploadActionType.PROGRESS as const,
  payload: { progress },
});

export function startUpload(fileName: string) {
  return { type: UploadActionType.START as const, payload: { fileName } };
}

export function error(message: string) {
  return { type: UploadActionType.ERROR as const, payload: { message } };
}

export function uploadComplete(workspaceId: string) {
  return {
    type: UploadActionType.OPEN_WORKSPACE as const,
    payload: { workspaceId },
  };
}
